import { Loader } from "@googlemaps/js-api-loader"

export class GoogleMapsLoader {
    constructor(apiKey) {
        this.apiKey = apiKey
        this._loader = null
    }

    async load() {
        if (!this.apiKey) {
            throw new Error('API Key não encontrada')
        }

        this._loader = new Loader({
            apiKey: this.apiKey,
            libraries: ["maps", "places", "geometry"],
            version: "weekly"
        })

        return await this._loader.load()
    }
}